export default class OrderItemAdditionalInfo {
    // todo
}